import { z } from "zod";

export const registerSchema = z
  .object({
    full_name: z.string().min(3, "Nome deve ter no mínimo 3 caracteres"),
    cpf: z.string().regex(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, "CPF inválido"),
    email: z.string().email("E-mail inválido"),
    phone: z.string().regex(/^\(\d{2}\) \d{5}-\d{4}$/, "Telefone inválido"),
    password: z
      .string()
      .min(8, "Senha deve ter no mínimo 8 caracteres")
      .refine(
        (v) => /[A-Z]/.test(v),
        "Senha deve conter ao menos uma letra maiúscula"
      )
      .refine(
        (v) => /[a-z]/.test(v),
        "Senha deve conter ao menos uma letra minúscula"
      )
      .refine((v) => /[0-9]/.test(v), "Senha deve conter ao menos um número")
      .refine(
        (v) => /[@$!%*?&#]/.test(v),
        "Senha deve conter ao menos um caractere especial (@$!%*?&#)"
      ),
    confirmPassword: z.string(),
    zip_code: z.string().regex(/^\d{5}-\d{3}$/, "CEP inválido"),
    street: z.string().min(3, "Rua inválida"),
    number: z.string().min(1, "Número obrigatório"),
    neighborhood: z.string().min(3, "Bairro inválido"),
    city: z.string().min(3, "Cidade inválida"),
    state: z.string().length(2, "Estado deve ter 2 caracteres"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "As senhas não coincidem",
    path: ["confirmPassword"],
  });

export type RegisterFormData = z.infer<typeof registerSchema>;

export const loginSchema = z.object({
  email: z.string().email("E-mail inválido"),
  password: z.string().min(8, "Senha deve ter no mínimo 8 caracteres"),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const recoveryPasswordSchema = z.object({
  email: z.string().email("E-mail inválido"),
});

export type RecoveryPasswordFormData = z.infer<typeof recoveryPasswordSchema>;

export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(8, "Senha deve ter no mínimo 8 caracteres")
      .refine(
        (v) => /[A-Z]/.test(v),
        "Senha deve conter ao menos uma letra maiúscula"
      )
      .refine(
        (v) => /[a-z]/.test(v),
        "Senha deve conter ao menos uma letra minúscula"
      )
      .refine((v) => /[0-9]/.test(v), "Senha deve conter ao menos um número")
      .refine(
        (v) => /[@$!%*?&#]/.test(v),
        "Senha deve conter ao menos um caractere especial (@$!%*?&#)"
      ),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "As senhas não coincidem",
    path: ["confirmPassword"],
  });

export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;
